import axios from 'axios';
import routes from 'services/routes';
import { random } from 'lodash';

export const cadastrarUsuario = info => (
  axios.post(routes.user.cadastro(), info)
);

export const confirmacaoEmail = info => (
  axios.post(routes.user.confirmacaoEmail(), info)
);

export const confirmacaoConvite = params => (
  axios.post(routes.auth.confirmacaoConvite(), params)
);

export const enviarEmailCadastro = info => (
  axios.post(routes.user.enviarEmailCadastro(), info)
);

export const forgetPassword = email => (
  axios.post(routes.auth.forgetPassword(), { email })
);

export const login = (username, password) => (
  axios.post(routes.auth.login(), `username=${username}&password=${password}&grant_type=password`)
);

// A lib no servidor requer um header que está sendo forçadamente adicionado via o fake authToken.
export const logout = () => (
  axios.post(routes.auth.logout(), `authToken=${random(0, 100000)}.${random(0, 100000)}`)
);

export const resetPassword = params => (
  axios.post(routes.auth.reset(), params)
);

export const updateUserPassword = params => (
  axios.post(routes.auth.update(), params)
);

export const updateUserInfo = params => (
  axios.post(routes.user.update(), params)
);



// WEBPACK FOOTER //
// ./src/services/auth.js